import { AppState } from '../../../../store/app.state'
import { PerfectScrollbarState } from './perfect-scrollbar.reducer'
import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store'
import { StoreKeysEnum } from '../../../../store/store-keys'

// For select TOP level store feature
export const selectPerfectScrollbarFeature = createFeatureSelector<Record<string, PerfectScrollbarState>>(StoreKeysEnum.PerfectScrollbarComponent)

// General selector Directly access property of state. Can select any part of the state
export const selectPerfectScrollbar = (state: AppState): Record<string, PerfectScrollbarState> => state?.[StoreKeysEnum.PerfectScrollbarComponent]

export const selectPerfectScrollbarByKey = (key: string): MemoizedSelector<any, any> => createSelector(
    selectPerfectScrollbar,
    (perfectScrollbarState): PerfectScrollbarState => perfectScrollbarState?.[key]
)

export const selectPerfectScrollbarLoadState = (key: string): MemoizedSelector<any, any> => createSelector(
    selectPerfectScrollbarByKey(key),
    (perfectScrollbar): PerfectScrollbarState => perfectScrollbar?.loadState
)

export const selectPerfectScrollbarTotalCount = (key: string): MemoizedSelector<any, any> => createSelector(
    selectPerfectScrollbarByKey(key),
    (perfectScrollbar): PerfectScrollbarState => perfectScrollbar?.totalCount
)

export const selectPerfectScrollbarParams = (key: string): MemoizedSelector<any, any> => createSelector(
    selectPerfectScrollbarByKey(key),
    (perfectScrollbar): PerfectScrollbarState => perfectScrollbar?.params
)

export const selectPerfectScrollbarState = (key: string): MemoizedSelector<any, any> => createSelector(
    selectPerfectScrollbarLoadState(key),
    selectPerfectScrollbarTotalCount(key),
    (loadState, totalCount): IPerfectScrollbarState => ({
        loadState: loadState ?? false,
        totalCount: totalCount ?? 0
    })
)

export const selectPerfectScrollbarStateWithParams = (key: string): MemoizedSelector<any, any> => createSelector(
    selectPerfectScrollbarLoadState(key),
    selectPerfectScrollbarTotalCount(key),
    selectPerfectScrollbarParams(key),
    (loadState, totalCount, params): IPerfectScrollbarStateWithParams => ({
        loadState: loadState ?? false,
        totalCount: totalCount ?? 0,
        params: params ?? {}
    })
)

export const selectPerfectScrollbarRootEl = (key: string): Object => createSelector(
    selectPerfectScrollbarByKey(key),
    state => state?.rootElement
)

// Select globalStatePath[attribute] or globalStatePath[nestedKey][attribute]
export const selectOriginFeatureByKey = (key: string, attr: string, target: string): any => (state: AppState) => {
    return target ? state[key]?.[target][attr] : state[key]?.[attr]
}

export interface IPerfectScrollbarState {
    loadState: boolean;
    totalCount: number;
}

export interface IPerfectScrollbarStateWithParams extends IPerfectScrollbarState {
    params: any;
}
